<template>
    <div>
        <div class="row mb-3">
            <div class="col-lg-3">
                <div class="form-group">
                    <label class="form-check-label" for="includeDriversWhoHaveLeft">
                        <input
                            v-model="filters.includeDriversWhoHaveLeft"
                            class="form-check-input me-1"
                            type="checkbox"
                            id="includeDriversWhoHaveLeft"
                        >
                        Include drivers who have left the company
                    </label>
                </div>
            </div>
            <div class="col-lg-9">
                <label>
                    <strong>
                        Licence Type
                    </strong>
                </label>
                <div class="row">
                    <div class="col-lg-4" v-for="(type, index) in licenceTypes" :key="index">
                        <div class="checkbox checkbox-primary">
                            <label>
                                <input v-model="filters.licenceTypes" class="me-1" type="checkbox" name="licenceType[]" :value="type.id" />
                                {{ type.type }}
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <table ref="tableRef" class="table table-bordered table-striped table-vcenter dataTable" style="width: 100%;">
            <thead>
                <tr>
                    <th v-if="!hide.includes('name')">Name</th>
                    <th v-if="!hide.includes('licenceNumber')">Licence Number</th>
                    <th v-if="!hide.includes('licenceTypes')">Licence Types</th>
                    <th v-if="!hide.includes('licenceExpiry')">Licence Expiry</th>
                    <th v-if="!hide.includes('actions')">Actions</th>
                </tr>
            </thead>
            <tbody></tbody>
        </table>
    </div>
</template>

<script setup>
import { reactive, onMounted, ref, watch } from "vue";
import { buildColumns } from "@/helpers/build-columns";

const props = defineProps({
    ajaxUrl: {
        type: String,
        required: true,
    },
    hide: {
        type: Array,
        default: () => [],
        required: false
    },
    licenceTypes: Array,
});

const tableRef = ref(null);

const filters = reactive({
    includeDriversWhoHaveLeft: false,
    licenceTypes: [],
});

const columnDefinitions = reactive({
    name: {
        name: 'name',
        width: '150px',
        render: function ( data, type, row ) {
            return row.computed_name;
        },
    },
    licenceNumber: {
        data: 'licence_number',
        width: '200px',
    },
    licenceTypes: {
        searchable: false,
        orderable: false,
        render: function ( data, type, row ) {
            return row.computed_licence_types;
        },
    },
    licenceExpiry: {
        data: 'computed_licence_expiry_date',
        searchable: false,
        width: '200px'
    },
    actions: {
        data: 'actions',
        searchable: false,
        orderable: false,
        width: '200px',
    }
});

const setColumnWidths = () => {
    let columnDefs = [];

    if (!props.hide.includes('actions')) {
        columnDefs.push({ targets: -1, width: '200px' });
    }

    return columnDefs;
};

onMounted(() => {
    const table = window.jQuery(tableRef.value).on('preXhr.dt', (e, settings, data) => {
        data.filters = filters;
    }).dataTable({
        processing: true,
        serverSide: true,
        pageLength: 25,
        lengthMenu: [25, 50, 100],
        ajax: {
            url: props.ajaxUrl,
        },
        columnDefs: setColumnWidths(),
        autoWidth: false,
        order: [[1, 'asc']],
        columns: buildColumns(columnDefinitions, props.hide),
    });

    // watch filters to reload table when they change
    watch(
        filters,
        () => table.api().ajax.reload(null, false),
        {
            deep: true
        }
    );
});
</script>
